import React from 'react';
import { PlayerContextType } from './types';

export const PlayerContext = React.createContext<PlayerContextType>({} as PlayerContextType);
